import { formatHoursMinutes, isIsraelDst } from './date';

export { isIsraelDst } from './date';

export function hourFromCompactTime(str) {
  return Math.floor(parseInt(str, 10) / 100);
}

export function minuteFromCompactTime(str) {
  return parseInt(str, 10) % 100;
}

export function stringToTime(str, adaptToDst = false) {
  return formatHoursMinutes(
    hourFromCompactTime(str) + (adaptToDst && isIsraelDst() ? 1 : 0),
    minuteFromCompactTime(str)
  );
}

export function numbersToTime(hours, minutes, adaptToDst = false) {
  return formatHoursMinutes(hours + (adaptToDst && isIsraelDst() ? 1 : 0), minutes);
}
